module.exports = __webpack_public_path__ + "static/img/application4-4.a487bc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-4.jpg
// module id = 3qEF
// module chunks = 0